import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./core/routes/login";
import { Home } from "./core/routes/home";
import { UsersPage } from "./core/routes/users";
import { SettingsPage } from "./core/routes/settings";
import { ProfilePage } from "./core/routes/profile";
import { Shell } from "./core/components/layout/shell";
import { useAuthStore } from "./core/stores/auth";
import { MODULES } from "./modules/index";
import type { AppRoute } from "./core/modules";

const CORE_ROUTES: AppRoute[] = [
  { path: "/utilisateurs", element: <UsersPage />, adminOnly: true },
  { path: "/reglages", element: <SettingsPage />, adminOnly: true },
  { path: "/profil", element: <ProfilePage /> },
];

/** Partie connectée : shell + routes du noyau et des modules actifs. */
function Protected() {
  const { user, loading, refresh } = useAuthStore();

  useEffect(() => {
    void refresh();
  }, [refresh]);

  if (loading) return <div className="boot">Chargement…</div>;
  if (!user) return <Login />;

  const guard = (r: AppRoute) =>
    r.adminOnly && user.role !== "admin" ? <Navigate to="/" replace /> : r.element;

  return (
    <Shell modules={MODULES}>
      <Routes>
        <Route path="/" element={<Home modules={MODULES} />} />
        {[...CORE_ROUTES, ...MODULES.flatMap((m) => m.routes)].map((r) => (
          <Route key={r.path} path={r.path} element={guard(r)} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  const publicRoutes = MODULES.flatMap((m) => m.publicRoutes ?? []);
  return (
    <Routes>
      {publicRoutes.map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}
      <Route path="/*" element={<Protected />} />
    </Routes>
  );
}
